export default __webpack_public_path__ + "static/media/tour-library.ae2f94d8.svg";